import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotifications, markNotificationRead } from "../redux/slices/notificationSlice";
import { Link } from "react-router-dom";


const AdminNotifications = () => {

  const dispatch = useDispatch();
  const { items, loading, error, pagination } = useSelector((state) => state.notifications);

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(fetchNotifications({ role: "admin", page: currentPage, limit }));
  }, [dispatch, currentPage]);

  const handleMarkAsRead = (id) => {
    dispatch(markNotificationRead({ role: "admin", id }));
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.pages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="mb-0">Notifications</h5>
        </div>
        <div className="card-body">
          {loading ? (
            <p className="text-muted">Loading...</p>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : items.length === 0 ? (
            <p className="text-muted">No notifications available</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-sm table-bordered table-striped">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Message</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((notification, index) => (
                      <tr
                        key={notification._id}
                        className={notification.isRead ? "" : "table-primary"}
                      >
                        <td>{(currentPage - 1) * limit + index + 1}</td>
                        <td>
                          {notification.link ? (
                            <Link to={notification.link}>{notification.message}</Link>
                          ) : (
                            notification.message
                          )}
                        </td>
                        <td>
                          {notification.isRead ? (
                            <span className="badge bg-success">Read</span>
                          ) : (
                            <span className="badge bg-warning text-dark">Unread</span>
                          )}
                        </td>
                        <td>
                          {!notification.isRead && (
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => handleMarkAsRead(notification._id)}
                            >
                              Mark as Read
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <nav>
                <ul className="pagination justify-content-center">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </button>
                  </li>
                  {Array.from({ length: pagination.pages || 1 }, (_, i) => (
                    <li
                      key={i}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${currentPage === pagination.pages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminNotifications;
